const px = (id, w = 1920) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const WHATSAPP_NUMBER = "447999976439";
export const WHATSAPP_DISPLAY = "+44 7999 976439";
export const BRAND = "Meet The Gods Ecotrails";
export const BRAND_PLAIN = "Meet The Gods";
export const BRAND_ACCENT = "Ecotrails";

export const IMAGES = {
  hero: px(35886474, 2400),
  tigerPath: px(36530920),
  tigerForest: px(15345428),
  tigerPortrait: px(11996336),
  tigerSunlit: px(36785736),
  elephantBandipur: px(982021),
  elephantMysuru: px(23548704),
  elephantCalf: px(35170201),
  wayanadTea: px(28196334),
  wayanadRoad: px(34130875),
  wayanadHills: px(36695891),
  peacock: px(38365697),
  beeEater: px(38782127),
  rollerBird: px(35484542),
  houseboatLotus: px(37185468),
  houseboatSunrise: px(32518360),
  fishingNetsSunset: px(35432098, 2400),
  fishingNetsCalm: px(34174745),
  fishingNetsTwilight: px(29666645),
  kathakaliBackstage: px(31843397),
  theyyam: px(14359116),
  mysorePalace: px(14702568),
  somanathapura: px(31355473),
  trainWindow: px(3732475),
  bengaluru: px(14845309),
};

export const NAV_LINKS = [
  { label: "Overview", href: "#journey" },
  { label: "Highlights", href: "#highlights" },
  { label: "Itinerary", href: "#itinerary" },
  { label: "Pricing", href: "#pricing" },
  { label: "Inclusions", href: "#details" },
];

export const STATS = [
  { icon: "MapPin", value: "08 Stops", label: "One seamless arc" },
  { icon: "CalendarDays", value: "12 Days", label: "11 nights" },
  { icon: "Binoculars", value: "04 Safaris", label: "Kabini–Nagarhole" },
  { icon: "Feather", value: "300+ Birds", label: "Species in reach" },
];

export const ROUTE_STOPS = [
  { days: "01", place: "Bengaluru" },
  { days: "02", place: "Mysuru · via Channapatna" },
  { days: "03–05", place: "Kabini · Nagarhole" },
  { days: "05–07", place: "Wayanad" },
  { days: "07–08", place: "Thalassery · Malabar Coast" },
  { days: "08–10", place: "Thattekad" },
  { days: "10–11", place: "Kumarakom · Vembanad" },
  { days: "11–12", place: "Fort Kochi" },
];

export const ROUTE_NOTE = "≈ 730–800 km by road · plus the Malabar rail journey";

export const OVERVIEW_QUOTE =
  "In Kabini, the forest does not perform for you. It simply continues — and for once, you are quiet enough to notice.";

export const CRAFTED_FOR = [
  {
    index: "01",
    icon: "Camera",
    title: "Wildlife Photographers",
    text: "Four safaris and a dedicated birding day — drives placed at dawn and dusk, built around light, not checklists.",
  },
  {
    index: "02",
    icon: "Hourglass",
    title: "Slow Travellers",
    text: "Long stays, quiet mornings, a rail journey through paddy fields, and room to simply be inside a place.",
  },
  {
    index: "03",
    icon: "UtensilsCrossed",
    title: "Culture & Food Lovers",
    text: "Mysuru's silk and sandalwood, Hoysala temples, Thalassery's kitchens, Theyyam and a Kerala sadhya.",
  },
  {
    index: "04",
    icon: "Heart",
    title: "Couples & Solo Naturalists",
    text: "Private departures on request, small groups only — shaped around your pace and curiosity.",
  },
];

export const HIGHLIGHTS = [
  { index: "01", day: "Day 02", title: "Channapatna toys, Mysore silk & sandalwood craft" },
  { index: "02", day: "Day 02", title: "The magnificent Mysore Palace" },
  { index: "03", day: "Day 03", title: "Hoysala stone carvings of Somanathapura" },
  { index: "04", day: "Day 04–05", title: "Four safaris in Kabini–Nagarhole" },
  { index: "05", day: "Day 06", title: "Tea estates & tribal heritage of Wayanad" },
  { index: "06", day: "Day 07", title: "Thalassery's kitchens & the Theyyam ritual" },
  { index: "07", day: "Day 09", title: "Endemic birds of Thattekad's forests" },
  { index: "08", day: "Day 10", title: "Houseboat & sadhya on Vembanad Lake" },
];

export const ITINERARY = [
  {
    day: "01",
    title: "Arrive in Bengaluru",
    drive: null,
    overnight: "Bengaluru",
    text: "Arrive in Bengaluru and settle into your hotel. Depending on your arrival time, enjoy a relaxed heritage or city walk and a first taste of South Indian cuisine.",
    bullets: ["Meet & assist on arrival", "Heritage or city walk, time permitting", "South Indian cuisine in the evening"],
    image: IMAGES.bengaluru,
    imageAlt: "The garden city of Bengaluru",
  },
  {
    day: "02",
    title: "Bengaluru → Channapatna → Mysuru",
    drive: "~145 km",
    overnight: "Mysuru",
    text: "Pause in Channapatna, renowned for its traditional wooden toys and lacquerware, before continuing to Mysuru — the palace, the silk looms and the sandalwood workshops of the old royal city.",
    bullets: ["Channapatna — wooden toys & lacquerware", "Mysore Palace exploration", "Mysore silk production showroom", "Sandalwood craftsmanship introduction"],
    image: IMAGES.mysorePalace,
    imageAlt: "The magnificent Mysore Palace",
  },
  {
    day: "03",
    title: "Mysuru → Somanathapura → Kabini",
    drive: "~150 km",
    overnight: "Kabini",
    text: "Travel through rural Karnataka to Somanathapura and the magnificent Chennakeshava Temple — celebrated for its intricate Hoysala architecture — then continue to the forests of Kabini and your wildlife lodge.",
    bullets: ["Rural Karnataka drive to Somanathapura", "Chennakeshava Temple — Hoysala carvings", "Onward to the forests of Kabini", "Check in to your wildlife lodge"],
    image: IMAGES.somanathapura,
    imageAlt: "12th-century Hoysala carvings at Somanathapura",
  },
  {
    day: "04",
    title: "Kabini · Nagarhole — Two Safaris",
    drive: "Local safari drives",
    overnight: "Kabini",
    text: "A dedicated wildlife photography day with morning and afternoon safaris — searching the Kabini–Nagarhole landscape for elephants, gaur, deer, wild dogs and rich birdlife, with the possibility of leopard or tiger.",
    bullets: ["Morning safari in Nagarhole", "Afternoon safari at golden hour", "Elephants, gaur, deer & wild dogs", "Leopard and tiger territory"],
    image: IMAGES.tigerPath,
    imageAlt: "A tiger walking a forest path in Nagarhole",
  },
  {
    day: "05",
    title: "Kabini → Wayanad",
    drive: "~110–130 km",
    overnight: "Wayanad",
    text: "Begin with the third and fourth safaris, completing four safari experiences across two days. Then drive through the Western Ghats to Wayanad and your plantation or nature-based stay.",
    bullets: ["Third and fourth safaris", "Four safaris across two days, complete", "Drive through the Western Ghats", "Plantation stay in Wayanad"],
    image: IMAGES.elephantBandipur,
    imageAlt: "A wild elephant in the Kabini–Nagarhole belt",
  },
  {
    day: "06",
    title: "Wayanad — Local Exploration",
    drive: "~30–50 km local",
    overnight: "Wayanad",
    text: "Explore Wayanad's plantation landscape — coffee, pepper, cardamom and tea — with a tea estate and factory visit. Later, a responsible tribal and community interaction around traditional knowledge, food, crafts and forest life.",
    bullets: ["Coffee, pepper, cardamom & tea estates", "Tea factory — cultivation to cup", "Responsible tribal community interaction", "Traditional knowledge, food & crafts"],
    image: IMAGES.wayanadTea,
    imageAlt: "Rolling tea estates of Wayanad",
  },
  {
    day: "07",
    title: "Wayanad → Thalassery",
    drive: "~80–100 km",
    overnight: "Thalassery",
    text: "Descend from the Western Ghats to the Malabar coast. Discover Thalassery's culinary heritage, local markets and coastal culture — and when the season and a performance align, the powerful ritual tradition of Theyyam.",
    bullets: ["Descend to the Malabar coast", "Thalassery's culinary heritage & markets", "Coastal culture, unhurried", "Theyyam ritual, when in season"],
    image: IMAGES.theyyam,
    imageAlt: "A Theyyam performer in ritual attire",
  },
  {
    day: "08",
    title: "Thalassery → Aluva → Thattekad",
    drive: "Train + ~55–65 km road",
    overnight: "Thattekad",
    text: "Travel by train from Thalassery to Aluva — Kerala's villages, paddy fields, coconut groves and everyday life unfolding along the railway — then continue by road into the forested landscape of Thattekad.",
    bullets: ["Train journey, Thalassery to Aluva", "Paddy fields & coconut groves by rail", "Everyday Kerala along the line", "Onward by road to Thattekad"],
    image: IMAGES.trainWindow,
    imageAlt: "Green fields framed by a train window",
  },
  {
    day: "09",
    title: "Thattekad — Birding",
    drive: "~20–40 km local",
    overnight: "Thattekad",
    text: "A dedicated birdwatching and photography day in the Western Ghats — exploring forests, plantations and surrounding habitats with an experienced birding guide, looking for endemic and resident species.",
    bullets: ["Dedicated birding & photography day", "Forests and plantations with an expert guide", "Endemic & resident Western Ghats species"],
    image: IMAGES.peacock,
    imageAlt: "A peacock displaying in the forest understorey",
  },
  {
    day: "10",
    title: "Thattekad → Kumarakom",
    drive: "~90–100 km",
    overnight: "Kumarakom · Houseboat",
    text: "Travel from the Western Ghats towards the Kerala backwaters. Enjoy a traditional houseboat experience on Vembanad Lake — villages, paddy fields and coconut groves drifting past — completed with a traditional Kerala sadhya.",
    bullets: ["Drive from the Ghats to the backwaters", "Traditional houseboat on Vembanad Lake", "Village life along the water", "A traditional Kerala sadhya"],
    image: IMAGES.houseboatLotus,
    imageAlt: "A houseboat among lotus flowers on Vembanad Lake",
  },
  {
    day: "11",
    title: "Kumarakom → Fort Kochi",
    drive: "~55–65 km",
    overnight: "Fort Kochi",
    text: "Travel to historic Fort Kochi and explore its multicultural heritage — Chinese fishing nets, colonial streets, historic churches and the waterfront — with a relaxed evening in the heritage quarter.",
    bullets: ["Chinese fishing nets & the waterfront", "Colonial streets and historic churches", "Multicultural heritage of the old port", "Relaxed evening in the heritage quarter"],
    image: IMAGES.fishingNetsCalm,
    imageAlt: "A Chinese fishing net over calm water in Fort Kochi",
  },
  {
    day: "12",
    title: "Fort Kochi → Departure",
    drive: "~40–45 km to airport",
    overnight: "Departure",
    text: "Depending on your departure time, enjoy a final morning in Fort Kochi, Mattancherry or Jew Town, before your transfer to Cochin International Airport.",
    bullets: ["Final morning in Fort Kochi or Mattancherry", "Jew Town's spice markets", "Transfer to Cochin International Airport"],
    image: IMAGES.fishingNetsTwilight,
    imageAlt: "Fishing nets at twilight, Fort Kochi",
  },
];

export const PHOTO_NOTES = [
  {
    title: "Light-first scheduling",
    text: "Safaris, cruises and walks are placed at dawn or dusk. Midday is for rest, review and editing — never for chasing sightings in flat light.",
  },
  {
    title: "Senior naturalists",
    text: "Guides who read alarm calls and pugmarks, position vehicles for backgrounds and angles, and understand what a photographer needs before you ask.",
  },
  {
    title: "Small groups, quiet vehicles",
    text: "Private departures on request, small groups only. Fewer lenses per sighting, more time at each, and silence when it matters.",
  },
  {
    title: "Beyond the mammals",
    text: "Theyyam in the firelight, Hoysala stone at noon, fishing nets at blue hour — the journey is sequenced for a portfolio, not just a species list.",
  },
];

export const INCLUSIONS = [
  "Accommodation on a twin-share basis throughout",
  "Breakfast every day of the 12-day journey",
  "5 dinners — Days 1, 2, 3, 4 and 11",
  "Guided wildlife safaris — 4 safari sessions",
  "Guided bird photography and birding experience",
  "Guided forest experience in the Western Ghats",
  "Guided heritage walk",
  "Guided spice trail experience",
  "Local cooking classes",
  "Local village experiences",
  "Private houseboat cruise and overnight stay",
  "All experiences mentioned in the itinerary",
];

export const EXCLUSIONS = [
  { title: "International airfare", text: "Flights to Bengaluru and home from Kochi." },
  { title: "Other meals", text: "Meals other than those specifically mentioned in the inclusions." },
  { title: "Insurance", text: "Medical and travel insurance, which we strongly recommend." },
  { title: "Indian visa", text: "Visa arrangements and fees for entry into India." },
  { title: "Unlisted services", text: "Any services not specifically mentioned under inclusions." },
  { title: "Personal expenses", text: "Laundry, beverages, telephone calls and similar." },
  { title: "Bottled water", text: "Drinking water and bottled water during the journey." },
];

export const ROOM_TIERS = [
  {
    name: "Travel with a Companion",
    price: "Twin-share",
    per: "The journey price is based on two sharing",
    badge: "Included in journey price",
    featured: true,
    lines: [
      "Bring a travel buddy and share a room",
      "Twin-share accommodation throughout",
      "The classic way this journey runs",
    ],
  },
  {
    name: "Single Supplement",
    price: "+€500",
    per: "One-time · private room throughout the tour",
    badge: null,
    featured: false,
    lines: [
      "Your own private space every night",
      "Applies across the full journey",
      "Made for solo travellers",
    ],
  },
  {
    name: "Private Houseboat",
    price: "+€200",
    per: "Per person · for the single traveller",
    badge: null,
    featured: false,
    lines: [
      "A private houseboat on Vembanad",
      "Your own crew and your own pace",
      "The backwaters, entirely yours",
    ],
  },
];

export const EXPERIENCES = [
  {
    title: "Additional night after the tour",
    price: "€90 per person",
    text: "A more relaxed departure, on request — accommodation, meals and transportation to the airport all included.",
  },
  {
    title: "Ayurvedic treatment or massage",
    price: "€45 per person",
    text: "Optional, but highly recommended — a must-try Kerala experience, arranged with a qualified practitioner.",
  },
];

export const FAQS = [
  {
    q: "When is the best season for this journey?",
    a: "November to April offers the finest conditions — dry forests concentrate wildlife at water sources, the Ghats are clear and cool, and the backwaters are at their most serene. Theyyam season runs roughly October to May near Thalassery, and we time departures around performances wherever possible.",
  },
  {
    q: "How large are the groups?",
    a: "Private departures on request, small groups only. We never run large coach-style departures — most journeys travel with four to eight guests, or entirely privately for couples, families and solo travellers.",
  },
  {
    q: "What camera gear should I bring?",
    a: "A telephoto of 400mm or more is ideal for Kabini and Thattekad; a fast 70–200mm covers most forest work, and a wide angle earns its keep at the temples and the coast. Beanbags are provided in vehicles, and our naturalists help with settings and positioning in the field.",
  },
  {
    q: "How physically demanding is it?",
    a: "Gentle to moderate. Safaris are vehicle based, and the rail journey, houseboat and plantation walks are unhurried. Every walk can be tailored or swapped for rest.",
  },
  {
    q: "Can dietary needs be accommodated?",
    a: "Fully. Vegetarian, vegan, Jain and allergy-aware meals are arranged at every lodge, on the houseboat and on every walk — South India is, in any case, one of the world's great vegetarian kitchens.",
  },
  {
    q: "Are there camera charges on safari?",
    a: "Mobile phone photography is free. Professional still cameras, video equipment and larger telephoto lenses may attract forest-department charges of roughly €10–20 per safari depending on the equipment — across the four safaris, keep aside about €40–60 per person. The final amount depends on park regulations and the gear you carry.",
  },
  {
    q: "How do bookings and payments work?",
    a: "Send an enquiry below — we confirm dates and availability personally over WhatsApp. A deposit secures your departure, with the balance due 45 days before travel. Flexible rescheduling applies to all bookings.",
  },
];
